(function () {
  const init = (root) => {
    const track = root.querySelector('[data-hero-carousel-track]');
    if (!track) return;

    const slides = Array.from(track.querySelectorAll('[data-hero-slide]'));
    if (slides.length === 0) return;

    const dots = Array.from(root.querySelectorAll('[data-hero-dot]'));
    const prevBtn = root.querySelector('[data-hero-prev]');
    const nextBtn = root.querySelector('[data-hero-next]');
    const autoplay = root.dataset.autoplay === 'true';
    const autoplayMs = parseInt(root.dataset.autoplayMs, 10) || 6000;

    let currentIndex = 0;
    let autoplayTimer = null;
    let isUserInteracting = false;

    const goTo = (index, { smooth = true } = {}) => {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      currentIndex = index;
      const target = slides[index];
      track.scrollTo({
        left: target.offsetLeft,
        behavior: smooth ? 'smooth' : 'auto',
      });
      updateUi();
    };

    const updateUi = () => {
      dots.forEach((dot, i) => {
        const active = i === currentIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      slides.forEach((slide, i) => {
        const video = slide.querySelector('[data-hero-video]');
        if (!video) return;
        if (i === currentIndex) {
          video.currentTime = 0;
          const p = video.play();
          if (p && typeof p.catch === 'function') p.catch(() => {});
        } else {
          video.pause();
        }
      });
    };

    const syncIndexFromScroll = () => {
      const viewportCenter = track.scrollLeft + track.clientWidth / 2;
      let closest = 0;
      let closestDist = Infinity;
      slides.forEach((slide, i) => {
        const center = slide.offsetLeft + slide.offsetWidth / 2;
        const dist = Math.abs(center - viewportCenter);
        if (dist < closestDist) {
          closestDist = dist;
          closest = i;
        }
      });
      if (closest !== currentIndex) {
        currentIndex = closest;
        updateUi();
      }
    };

    const startAutoplay = () => {
      if (!autoplay || slides.length < 2) return;
      stopAutoplay();
      autoplayTimer = window.setInterval(() => {
        if (document.hidden || isUserInteracting) return;
        goTo(currentIndex + 1);
      }, autoplayMs);
    };

    const stopAutoplay = () => {
      if (autoplayTimer) {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const i = parseInt(dot.dataset.heroDot, 10) || 0;
        goTo(i);
      });
    });

    if (prevBtn) prevBtn.addEventListener('click', () => goTo(currentIndex - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => goTo(currentIndex + 1));

    let scrollTimeout = null;
    track.addEventListener('scroll', () => {
      if (scrollTimeout) window.clearTimeout(scrollTimeout);
      scrollTimeout = window.setTimeout(syncIndexFromScroll, 150);
    }, { passive: true });

    ['pointerdown', 'touchstart', 'mouseenter', 'focusin'].forEach((evt) => {
      root.addEventListener(evt, () => { isUserInteracting = true; }, { passive: true });
    });
    ['pointerup', 'touchend', 'touchcancel', 'mouseleave', 'focusout'].forEach((evt) => {
      root.addEventListener(evt, () => { isUserInteracting = false; }, { passive: true });
    });

    root.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { goTo(currentIndex - 1); e.preventDefault(); }
      else if (e.key === 'ArrowRight') { goTo(currentIndex + 1); e.preventDefault(); }
    });

    updateUi();
    startAutoplay();

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stopAutoplay();
      else startAutoplay();
    });
  };

  const boot = () => {
    document.querySelectorAll('[data-hero-carousel]').forEach((el) => {
      if (el.dataset.heroCarouselInit === '1') return;
      el.dataset.heroCarouselInit = '1';
      init(el);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
